import { styled } from 'styled-components';
export const Wrapper = styled.div `
  ${({ theme }) => theme.shadows.medium}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  padding: 8px 0px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.grey00_6};
`;
